import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import env from "../../services/env.js";
import security from "../../services/security.js";
import tracking from "../../services/tracking.js";

class SignupController {
  constructor(
    $http,
    $rootScope,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    SecurityService,
    $timeout,
    $httpParamSerializerJQLike,
    TrackingService,
    SocialService,
    validation,
    ngProgressFactory,
    SignupValidator,
    SignupRouting,
    SignupFormatting,
    SignupTracking,
    SignupRegister,
    SignupCommon,
    ProfileService,
    CompanyService,
    $location
  ) {
    this.name = "signup";

    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$progress = ngProgressFactory.createInstance();
    this.$timeout = $timeout;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.$tracking = TrackingService;
    this.$social = SocialService;
    this.$validation = validation;
    this.routing = SignupRouting;
    this.format = SignupFormatting;
    this.tracking = SignupTracking;
    this.register = SignupRegister;
    this.smsAgreementVal = false;
    this.common = SignupCommon;
    this.$profile = ProfileService;
    this.$companies = CompanyService;
    this.step = 1;
    this.onboarding_step = 1;
    this.check_policy = false;
    this.remain_loading_count = 0;
    this.onboarding_card_state = "1";
    this.phone_class = "";
    this.result = {status: "", message: ""};
    this.$location = $location;
    this.isOnSiteManager = null;

    this.checkForOnSiteManagerInvite();

    if (this.$state && this.$state.current && this.$state.current.name) {
      if (this.$state.current.name.indexOf("1") !== -1) {
        this.onboarding_step = 1;
      }
      if (this.$state.current.name.indexOf("2") !== -1) {
        this.onboarding_step = 2;
      }
      if (this.$state.current.name.indexOf("3") !== -1) {
        this.onboarding_step = 3;
      }
      if (this.$state.current.name.indexOf("4") !== -1) {
        this.onboarding_step = 3;
      }
    }

    this.first_name = "";
    this.last_name = "";
    this.phone_number = "";
    this.display_phone_number = "";

    this.company_name = "";
    this.zip_code = "";
    this.password = "";

    this.city = "";
    this.state = "";
    this.email = "";
    this.posting_data = {};
    this.displayTOSModal = false;
    this.$location = $location;
    this.userInvited = false;
    this.userInvitedToken = "";
    this.message = "An email verification has been sent! Please click the link in that email to finish your registration.";

    this.states = {
      values: [
        "--",
        "AL",
        "AK",
        "AS",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "DC",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "PR",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    };

    this.cardNumberFormatting = {
      creditCard: true,
      delimiter: "-",
      onValueChanged: (e) => {
        this.cardNumber = e.target.rawValue.trim();
      },
    };

    const thisYear = new Date().getFullYear();
    const allYears = [thisYear.toString()];

    for (let i = 1; i < 15; i++) {
      allYears.push((thisYear + i).toString());
    }

    this.expYears = {value: thisYear.toString(), values: allYears};
    //this.expMonths = { "value" : thisMonth.toString(), "values" : monthsForDropDrown };
    this.expMonths = {
      value: "01",
      values: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
    };

    // Tracking
    this.posting_data = this.$stateParams;
    this.tracking.initFB();
    this.page = this.routing.routePage();

    // Validation variables
    this.validation = {};
    this.validator = SignupValidator;
    this.phoneFormatting = this.format.phoneFormatting(this);
    this.phoneFormattingOnboarding = this.format.phoneFormattingOnboarding(this);

    // Prevent validation before the user starts typing
    this.canValidate = false;
    this.$timeout(() => (this.canValidate = true), 1000);

    this.common.removeBodyClass();

    this.onboarding_data = {
      first_name: "34",
      last_name: "23",
      phone_number: 23,
      display_phone_number: "12323",
    };

    this.locationOptions = [
      {label: "1", value: 1},
      {label: "2", value: 2},
      {label: "3", value: 3},
      {label: "4", value: 4},
      {label: "5", value: 5},
      {label: "6", value: 6},
      {label: "7", value: 7},
      {label: "8", value: 8},
      {label: "9", value: 9},
      {label: "10+", value: 10},
    ];

    this.setInviteUserData();
    this.setOnboardingFields();

    this.$timeout(() => {
      $(".sign-up-page .input-container input:first").focus();
    }, 300);
  }

  setInviteUserData() {
    var _this = this;

    if (_this.$location) {
      _this.userInvitedToken = _this.$location.search().token;

      if (_this.userInvitedToken) {
        var req = {
          method: "GET",
          url: _this.$env.getAPIEndPoint() + "register/invite-user?action=inviteUserInfo&token=" + _this.userInvitedToken,
          headers: {
            "Content-Type": "application/json",
          },
        };
        _this
          .$http(req)
          .then(function (data) {
            if (data.data) {
              _this.userInvited = true;
              _this.company_name = data.data.invitedByCompanyDescription;
              _this.email = data.data.inviteeEmail;
              localStorage.lastUserInviteeEmail = data.data.inviteeEmail;

              let phone = data.data.invitedByCompanyPhoneNumber;

              if (!phone) {
                _this.display_phone_number = phone;
              } else {
                //_this.display_phone_number = _this.formatPhoneNumber(phone);
                if (phone.length == 11) {
                  phone = phone.slice(1);
                }
                _this.display_phone_number = "111" + phone;
              }

              _this.compareCurrentUser(data.data);
            }
          })
          .catch((err) => {
            this.handleInviteUserError(err);
          });
        return;
      }
    }
  }

  handleInviteUserError(err) {
    if (err.data.message === "This token is invalid") {
      this.result.status = "error";
      this.result.message = "The link in the invitation email you received has either expired or been canceled. Kindly review your inbox for a more recent invitation.";
    } else {
      this.result.status = "error";
      this.result.message = err.data.message;
    }
  }

  compareCurrentUser(invitedUser) {
    if (this.currentUser) {
      if (invitedUser.inviteeEmail !== this.currentUser.email) {
        this.$auth.logoutOnboarding();
      }
    }
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");

    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "+1 (" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  }

  setOnboardingFields() {
    const user = this.$auth.getUserData();

    this.currentUser = user;

    if (user) {
      this.$timeout(() => {
        this.already_registered = true;
        let phone = user.homeContactInfo && user.firstName ? user.homeContactInfo.phoneMobile : "";
        let company = user.company ? user.company : {};
        let companyContactInfo = company.mainContactInfo ? company.mainContactInfo : {};

        console.log("user.company", company);
        this.company_name = company.name;
        this.email = user.username;
        //this.password = "P@ssw0rd1!";
        this.phone_number = companyContactInfo.phoneMobile || "";

        if (localStorage.lastUserInviteeEmail === user.username) {
          this.userInvited = true;
        }

        if (companyContactInfo.phoneMobile && companyContactInfo.phoneMobile.length && companyContactInfo.phoneMobile[0] === "1") {
          this.display_phone_number = `+1 ${companyContactInfo.phoneMobile.slice(1)}`;
        } else {
          this.display_phone_number = `+1 ${companyContactInfo.phoneMobile}`;
        }

        this.onboarding_data = {
          first_name: user.firstName,
          last_name: user.lastName,
          display_phone_number: phone,
          phone_number: phone,
          legal_company_name: company.legalCompanyName,
          ein: company.ein,
          number_of_locations: (company.numberOfLocations || 0).toString(),
          company_name: company.name,
          company_street_address: companyContactInfo.streetLine1,
          company_city: companyContactInfo.city,
          company_state: companyContactInfo.state,
          company_zip_code: companyContactInfo.zipCode,
          userInvited: user.userInvited,
        };

        this.validatePersonalDetails();
        this.validateCompanyDetails();
        this.validateBankDetails();
        this.validateCardDetails();
      });
    }
  }

  setValidation({field, valid, message}) {
    if (this.canValidate)
      this.$timeout(() => {
        this.validation[field] = {
          valid,
          style: {borderColor: valid ? "green" : "red"},
          message,
        };
      });
    this.validation;
  }

  gotoSignIn() {
    this.common.closeVerificationModal();
    this.$timeout(() => {
      this.$localStorage.logged_user = this.currentUser;
      this.routing.routeSignInPage(this.posting_data, this.currentUser);
    }, 400);
  }

  bankDataChanging() {
    this.validateBankDetails();
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  validateCard() {
    let valid = true;

    this.validateCardErrorMessage = "";
    this.validateCardError = false;

    return true;

    const validCreditCardName = this.handleCreditCardNameChange();
    const validStreet = this.handleStreetChange();
    const validCity = this.handleCityChange();
    const validState = this.handleStateChange();
    const validZipCode = this.handleZipCodeChange();
    const validCardNumber = this.handleCardNumberChange();
    const validCVC = this.handleCVCChange();
    const validExpirationDate = this.handleExpirationDateChange();

    if (!validCreditCardName || !validStreet || !validCity || !validState || !validZipCode || !validCardNumber || !validCVC || !validExpirationDate)
      valid = false;

    if (!validCreditCardName) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide the name associated with this credit card.";
    }

    if (!validStreet) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide a street address.";
    }

    if (!validCity) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide a city.";
    }

    if (!validState) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide a state.";
    }

    if (!validZipCode) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide a zipcode.";
    }

    if (!validCardNumber) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Invalid card number.";
    }

    if (!validCVC) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Invalid cvc code.";
    }

    if (!validExpirationDate) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Invalid expiration date.";
    }

    this.isCreditCardDisabled = !valid;

    return valid;
  }

  createCard() {
    this.isCreditCardDisabled = true;

    if (!this.validateCard()) {
      return console.error("Invalid card. Not creating card");
    }

    let charge_on_creation = false;

    const myData = {
      card: {
        number: this.cardNumber,
        exp_month: this.expMonths.value,
        exp_year: this.expYears.value,
        cvc: this.cvc,
        address_line1: this.street,
        address_city: this.city,
        address_state: this.state,
        address_zip: this.zipCode,
        name: this.credit_card_name,
      },
    };

    let req = {
      method: "POST",
      url: "https://api.stripe.com/v1/tokens",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + this.$env.EnvironmentConfig.stripeKey,
      },
      data: this.$httpParamSerializerJQLike(myData),
    };

    // this.remain_loading_count++;

    this.$http(req).then(
      (response) => {
        // this.remain_loading_count--;

        req = {
          method: "POST",
          url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.currentUser.access_token,
          },
          data: {
            username: this.currentUser.username,
            stripeToken: response.data.id,
            nickname: this.nickname,
          },
        };

        // this.remain_loading_count++;

        let new_token_id = null;
        if (response.data.card) {
          new_token_id = response.data.card.id;
        } else {
          new_token_id = response.data.bank.id;
        }

        this.$http(req).then(
          (res) => {
            if (res.data.status !== "error") {
              this.cardNumber = "";
              this.expMonths.value = "";
              this.expYears.value = "";
              this.nickname = "";
              this.cvc = "";
              this.street = this.city = this.state = this.zipCode = "";
              const cardLoop = (value) => {
                this.$timeout(() => {
                  if (value > 0) {
                    this.currentUser = this.$auth.validateUserByTokenWeb(this.currentUser.access_token).then((r) => {
                      r.data.company.paymentInfos = r.data.company.undeletedPaymentInfos;
                      this.$localStorage.logged_user = r.data;
                      this.currentUser = r.data;
                      let result = this.currentUser.company.undeletedPaymentInfos.find((o) => o.stripeId === new_token_id);
                      if (result) {
                        this.$timeout(() => {
                          // this.remain_loading_count = 0;
                        }, 300);

                        this.$timeout(() => {
                          if (this.payForPost && !charge_on_creation) {
                            this.$rootScope.$emit("ShowPostModalCC", {
                              user: this.currentUser,
                              new_card: result,
                            });
                          } else if (this.payForPost && charge_on_creation) {
                            this.$rootScope.$emit("ChargeCreditCardForPost", {
                              user: this.currentUser,
                              new_card: result,
                              event: this.event_for_pay,
                            });
                          } else {
                            if (this.$rootScope.isSourcingJobForPayment) {
                              this.$rootScope.$emit("UpdatedCreditCardConnection", {});
                            }
                          }
                          this.$rootScope.$emit("UpdatedCreditCardConnectionCompletePage", {});
                          this.$rootScope.$emit("UpdatedCreditCard", {
                            user: this.currentUser,
                          });
                          this.$rootScope.$emit("SetRegisterCardStatus", {
                            status: 1,
                          });
                          this.isCreditCardDisabled = false;
                        }, 800);
                      } else {
                        cardLoop(value - 1);
                      }
                    });
                  } else {
                    this.isCreditCardDisabled = false;
                  }
                }, 1000);
              };
              cardLoop(10);
            } else {
              this.isCreditCardDisabled = false;
              this.validateCardError = true;
              this.validateCardErrorMessage = res.data.message;
              // this.remain_loading_count--;
            }
          },
          (res) => {
            this.validateCardError = true;
            this.isCreditCardDisabled = false;
            this.validateCardErrorMessage = "Error while registering a credit card.";
            this.$timeout(() => {
              this.$rootScope.$emit("SetRegisterCardStatus", {
                status: 2,
              });
              // this.remain_loading_count--;
            });
          }
        );
      },
      (response) => {
        // this.remain_loading_count--;
        this.isCreditCardDisabled = false;
        this.$timeout(() => {
          this.$rootScope.$emit("SetRegisterCardStatus", {
            status: 2,
          });
          this.validateCardError = true;
          this.validateCardErrorMessage = response.data.error.message;
        });
      }
    );
  }

  createBankAccount() {
    console.log("createBankAccount", this.isSaveBankAccountDisabled);
    this.setLoader();
    this.isSaveBankAccountDisabled = true;

    this.newBankAccount = {
      bank_account: {
        country: "us",
        currency: "usd",
        account_holder_name: null,
        account_holder_type: "company",
        routing_number: null,
        account_number: null,
      },
    };

    this.newBankAccount.bank_account.account_holder_name = this.accountHolderName;
    this.newBankAccount.bank_account.routing_number = this.routingNumber;
    this.newBankAccount.bank_account.account_number = this.accountNumber;

    console.log("what is the new bank account");
    console.dir(this.newBankAccount);

    const req = {
      method: "POST",
      url: "https://api.stripe.com/v1/tokens",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + this.$env.EnvironmentConfig.stripeKey,
      },
      data: this.$httpParamSerializerJQLike(this.newBankAccount),
    };

    this.$http(req).then(
      (response) => {
        console.log("-----------here is the tokens response...");
        console.dir(response);
        this.$timeout(() => {
          this.saveCustomerToJobbleAPI(response);
        }, 1000);

        this.validateCardError = false;
        this.unSetLoader();
      },
      (res) => {
        console.log("error here?");
        console.dir(res);
        this.validateCardError = true;
        this.validateCardErrorMessage = res.data.error.message;
        this.unSetLoader();
        this.$timeout(() => {
          this.$rootScope.$emit("SetRegisterCardStatus", {
            status: 2,
          });
        });
      }
    );
  }

  saveCustomerToJobbleAPI(response) {
    this.setLoader();

    const req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web&isBankToken=true",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.currentUser.access_token,
      },
      data: {
        username: this.currentUser.username,
        stripeToken: response.data.id,
      },
    };

    this.$http(req).then(
      (res) => {
        if (res.data.status !== "error") {
          this.routingNumber = undefined;
          this.accountNumber = undefined;
          this.accountHolderName = undefined;
          this.isSaveBankAccountDisabled = false;

          this.loopThroughPaymentInfo();

          console.log("this is the last thing we see.");
        } else {
          this.validateCardError = true;
          this.validateCardErrorMessage = res.data.message;
          this.isSaveBankAccountDisabled = false;
        }
        this.unSetLoader();
      },
      (res) => {
        this.validateCardError = true;
        this.validateCardErrorMessage = res.data.message;
        this.isSaveBankAccountDisabled = false;
        this.unSetLoader();
        this.$timeout(() => {
          this.$rootScope.$emit("SetRegisterCardStatus", {
            status: 2,
          });
        });
      }
    );
  }

  smsAgreement(agreed) {
    let user = {tcpaConsent: agreed};
    this.setLoader();
    this.$profile.saveUserBasic(user).then((response) => {
      this.unSetLoader();
    },
    (error) => {
      this.unSetLoader();
    });
  }

  loopThroughPaymentInfo() {
    const cardLoop = (value) => {
      this.$timeout(() => {
        if (value > 0) {
          this.currentUser = this.$auth.validateUserByTokenWeb(this.currentUser.access_token).then((r) => {
            console.log("Do we make it this far 3");
            this.$localStorage.logged_user = r.data;
            this.currentUser = r.data;
            this.currentUser.company.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
            if (this.currentUser.company.paymentInfos.length === this.paymentOptionsCounts + 1) {
              console.log("Do we make it this far 4");
              this.remain_loading_count = 0;
              this.$timeout(() => {
                this.paymentOptionsCounts = this.paymentOptionsCounts + 1;
                this.$rootScope.$emit("UpdatedBankAccounts", {});
                this.reloadBankAccounts();
              }, 100);
            } else {
              cardLoop(value - 1);
            }
          });
        } else {
          this.remain_loading_count = 0;

          this.$timeout(() => {
            // alert("Please give the system a moment to update your payment information. Please check back in a couple minutes.");
          }, 300);
        }
      }, 1000);
    };
    cardLoop(3);
  }

  reloadBankAccounts() {
    let partner = this.currentUser.company.partner;

    if (partner) {
      //this.displayModalExplainingMicroDep();
    }

    this.banksArray = [];

    this.$timeout(() => {
      this.currentUser = this.$auth.getUserData();
      this.paymentInfos = this.currentUser.company.paymentInfos;
      this.organizeBankAccounts();
    }, 100);
  }

  organizeBankAccounts() {
    this.paymentInfos.forEach((paymentInfo) => {
      if (paymentInfo.bankName) {
        this.banksArray.push(paymentInfo);
      }
    });
  }

  setNextStep() {
    const user = this.$auth.getUserData();
    console.log("setNextStep");
    console.dir(this.onboarding_step);
    if (this.onboarding_step === 3 && !this.userInvited) {
      this.$state.go("postashiftwalkthrough");
    } else if (this.onboarding_step === 4 || this.userInvited) {
      if (user.company.totalNumberOfEvents > 0) {
        this.$state.go("jobsdashboard");
      } else {
        this.$state.go("postashiftwalkthrough");
      }
    } else if (this.onboarding_step < 4) {
      if (this.currentUser.company.isVerified) {
        this.$state.go("jobsdashboard");
      } else {
        let new_step;
        if (this.onboarding_step === 2) {
          new_step = 3;
        } else {
          new_step = this.onboarding_step + 1;
        }
        console.log("we are going to this step");
        console.dir(new_step);
        this.$state.go(`company-onboarding-${new_step}`);
      }
    }
    this.enableToolTips();
  }

  saveUserInformation() {
    this.setLoader();

    const payload = {
      firstName: this.onboarding_data.first_name,
      lastName: this.onboarding_data.last_name,
      homeContactInfo: {
        phoneMobile: this.onboarding_data.phone_number,
      },
    };

    this.$profile.saveUserBasic(payload).then((response) => {
      this.$auth.refreshCurrentUser().then((user) => {
        console.log("Save response", response);
        this.unSetLoader();
      });
    });
  }

  saveUserInformationThenTriggerCode() {
    this.validPersonalDetails = false;
    this.setLoader();

    const payload = {
      firstName: this.onboarding_data.first_name,
      lastName: this.onboarding_data.last_name,
      homeContactInfo: {
        phoneMobile: this.onboarding_data.phone_number,
      },
    };

    this.$profile.saveUserBasic(payload).then((response) => {
      this.$auth.refreshCurrentUser().then((user) => {
        console.log("Save response", response);
        this.$timeout(() => {
          this.unSetLoader();
          this.validPersonalDetails = true;
          this.triggerSMSCode(response, user);
        }, 1000);
      }).catch((err) => {
        this.unSetLoader();
        this.validPersonalDetails = true;
        alert("Error saving user information.");
      });
    }).catch((error) => {
      this.unSetLoader();
      this.validPersonalDetails = true;
      alert("Error saving user information.");
    });
  }

  updateCompanyInformation() {
    this.$timeout(() => {
      // this.savingCompanyInformation = true;
    });

    const payload = {
      company_name: this.company_name,
      company_phone: this.phone_number,
    };

    this.$companies
      .saveCompanyProfileInformation(payload)
      .then((response) => {
        this.$timeout(() => {
          // this.savingCompanyInformation = false;
          // this.setNextStep();
        });

        this.$auth.refreshCurrentUser().then((user) => {
          console.log("Save company response", response);
        });
      })
      .catch((error) => {
        this.$auth.refreshCurrentUser().then((user) => {
          this.$timeout(() => {
            // this.savingCompanyInformation = false;
          });

          console.log("Save company error", error);
        });
      });
  }

  saveCompanyInformation() {
    this.$timeout(() => {
      this.savingCompanyInformation = true;
      this.invalidZipCode = false;
    });

    const payload = {
      company_name: this.onboarding_data.company_name,
      company_street_address: this.onboarding_data.company_street_address,
      company_city: this.onboarding_data.company_city,
      company_state: this.onboarding_data.company_state,
      company_zip_code: this.onboarding_data.company_zip_code,
      // ein: this.onboarding_data.ein,
      number_of_locations: this.onboarding_data.number_of_locations,
      legal_company_name: this.onboarding_data.legal_company_name,
    };

    this.$companies
      .saveCompanyProfileInformation(payload)
      .then((response) => {
        this.$timeout(() => {
          this.savingCompanyInformation = false;
          this.setNextStep();
        });

        this.$auth.refreshCurrentUser().then((user) => {
          console.log("Save company response", response);
        });
      })
      .catch((error) => {
        this.$auth.refreshCurrentUser().then((user) => {
          this.$timeout(() => {
            this.savingCompanyInformation = false;
            this.invalidZipCode = true;
          });

          console.log("Save company error", error);
          if (error && error.data && error.data.message && error.data.message.toLowerCase().indexOf("zip code") !== -1) {
            console.error("Invalid zip code");
            this.$timeout(() => {
              this.invalidZipCode = true;
            });
          }
        });
      });
  }

  uploadFilesNew(file, errors) {
    let fd = new FormData();

    this.setLoader();

    fd.append("file", file);

    if (errors.length > 0) {
      this.unSetLoader();
      alert("There is an issue with that image. Please choose a different one.");
      return;
    }

    if (file) {
      //console.log('the file actually is something');

      this.currentUser = this.$auth.getUserData();

      var uploadUrlCompany = this.$auth.getUploadUrl(this.currentUser.company.id, file);

      this.uploadingImage = true;
      this.$http
        .post(uploadUrlCompany, fd, {
          transformRequest: angular.identity,
          headers: {
            "Content-Type": undefined,
            Authorization: "Bearer " + this.currentUser.access_token,
          },
        })
        .then(
          (response) => {
            var callback = response.data;

            this.$timeout(() => {
              this.uploadingImage = false;

              this.currentUser.company.companyLogoUri = callback.mainFile.url;
              this.$rootScope.companyLogoUri = callback.mainFile.url;
              this.$rootScope.imgFromProfilePage = callback.mainFile.url;
              //this.determineImageDimensions(callback.mainFile.url);
              this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
              this.$auth.reloadCurrentUser();
              this.unSetLoader();
              this.$rootScope.$emit("SetProfilePicture", {
                picture: callback.mainFile.url,
              });
            }, 100);
          },
          (error) => {
            this.unSetLoader();
            this.$timeout(() => {
              this.uploadingImage = false;
              jQuery("#application-global-modal .modal-header button.close").trigger("click");
            }, 100);

            this.$timeout(() => {
              alert("There is an issue with that image. Please choose a different one.");
            }, 1000);
          }
        );
    }
  }

  determineImageDimensions(url) {
    console.log("determineImageDimensions");
    console.dir(url);

    let myImg = document.querySelector("#img-logo-company");

    console.log("myImg");
    console.dir(myImg);

    let imageClassForDisplay = this.$profile.dimensionsCalc(myImg.clientHeight, myImg.clientWidth);

    this.$timeout(() => {
      $("#img-logo-company").addClass(imageClassForDisplay);
    });
  }

  validatePersonalDetails() {
    this.validPersonalDetails = true;

    if (
      !this.onboarding_data.first_name ||
      !this.onboarding_data.last_name ||
      !this.onboarding_data.phone_number ||
      !this.onboarding_data.phone_number.length ||
      this.onboarding_data.phone_number.length < 10
    ) {
      this.validPersonalDetails = false;
    }
  }

  enableToolTips() {
    this.$timeout(() => {
      $(".onboarding-tool-tip").tooltip({}).tooltip("fixTitle");
    }, 200);
  }

  validateCompanyDetails() {
    this.enableToolTips();

    this.validCompanyDetails = true;

    const ssnPattern = /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/;
    const zipCodePattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

    if (
      !this.onboarding_data.company_name ||
      !this.onboarding_data.company_street_address ||
      // !this.onboarding_data.ein || !(ssnPattern.test(this.onboarding_data.ein)) ||
      !this.onboarding_data.legal_company_name ||
      !this.onboarding_data.number_of_locations ||
      !this.onboarding_data.company_city ||
      !this.onboarding_data.company_state ||
      !this.onboarding_data.company_zip_code ||
      !zipCodePattern.test(this.onboarding_data.company_zip_code)
    ) {
      this.validCompanyDetails = false;
    }
  }

  validateBankDetails() {
    this.validBankDetails = true;

    if (!this.accountHolderName || !this.accountNumber || !this.routingNumber) {
      this.validBankDetails = false;
    }

    if (!angular.isUndefined(this.accountHolderName) && !angular.isUndefined(this.routingNumber) && !angular.isUndefined(this.accountNumber)) {
      if (!(/^\w{1,17}$/.test(this.accountNumber) && this.routingNumber.length === 9)) {
        this.validBankDetails = false;
      }
    }
  }

  validateCardDetails() {
    this.validCardDetails = true;

    if (
      !this.credit_card_name ||
      !this.street ||
      !this.city ||
      !this.state ||
      !this.zipCode ||
      !this.cardNumber ||
      !this.expYears.value ||
      !this.expMonths.value ||
      !this.cvc
    ) {
      this.validCardDetails = false;
    }
  }

  signup() {
    console.log("signup");

    if (this.buttonDisabled === true) {
      return;
    }

    const vm = this;
    const validated = this.validator.validate(vm);
    if (!validated) return console.error("One of the sign up fields is invalid. Not processing signing up.");

    if (this.$auth.getUserData()) {
      console.warn("Company already created; submitting edit and skipping to onboarding");
      this.updateCompanyInformation();

      if (this.userInvited) {
        this.$state.go("company-onboarding-2");
      } else {
        this.$state.go("company-onboarding-1");
      }

      return;
    }

    const user = this.register.formatUserObject(vm);
    console.log("user here");
    console.dir(user);

    this.buttonDisabled = true;

    this.$progress.start();

    this.register.companySignup(user).then(({success, registerStatus, errorMessage, user}) => {
      this.handleSignup({
        success,
        registerStatus,
        errorMessage,
        user,
      });
    });

  }

  capitalizeFirstLetter(value, type) {
    if (value) {
      if (type === "firstName") {
        if (value.length === 2) {
          this.onboarding_data.first_name = value.charAt(0).toUpperCase() + value.slice(1);
        }
      } else if (type === "lastName") {
        this.onboarding_data.last_name = value.charAt(0).toUpperCase() + value.slice(1);
      }
    }

  }

  handleSignup({success, registerStatus, errorMessage, user}) {
    //console.log("Handling sign up. Remaining count:", this.remain_loading_count);

    if (success) {
      const {email, password} = user;

      this.$timeout(() => {
        this.register.loginUser({emailLogin: email, passwordLogin: password}).then(({success, user, error}) => {
          this.buttonDisabled = false;
          this.remain_loading_count--;
          this.handleLogin({success, user, error});
          this.$progress.complete();
          this.$tracking.reportGlobalSubmit("sign up - submit - new company sign up");
        });
      }, 5000);
    } else {
      this.buttonDisabled = false;

      if (registerStatus === "500") {
        this.$progress.complete();
        this.$timeout(() => {
          $("#show-application-alert").trigger("click");
        });
      }

      this.$timeout(() => {
        this.remain_loading_count = 0;
        this.$progress.complete();
        this.result.status = "error";
        this.result.message = errorMessage;
        console.log("Error shown. remaining count:", this.remain_loading_count);
      });
    }
  }

  submitOnEnter(e) {
    if (e.keyCode === 13) {
      this.signupJobbler();
    }
  }

  submitOnEnterCompany(e) {
    if (e.keyCode === 13) {
      this.signup();
    }
  }

  signupJobbler() {
    const validated = this.validator.validateJobbler(this);

    if (!validated) return console.error("One of the sign up fields is invalid. Not processing signing up.");

    this.buttonDisabled = true;
    this.common.setLoader();

    const user = this.register.formatJobblerObject(this);

    if (user && user.email) {
      var _hsq = window._hsq || [];
      window._hsq = _hsq;
      _hsq.push(["setPath", "/signup/jobbler"]);
      _hsq.push(["identify", {email: user.email}]);
      _hsq.push(["trackPageView"]);
      console.log("Hubspot logs", _hsq);
    }

    this.$auth.registerMobileUser(user).then(
      (response) => {
        this.handleJobblerSignUp(response);
      },
      (error) => {
        this.buttonDisabled = false;
        window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>Error registering. Please contact support.");
      }
    );
  }

  handleJobblerSignUp(response) {
    this.buttonDisabled = false;

    if (response.data.status === "error") {
      if (response.data.message.indexOf("Duplicate entry") > -1) {
        window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>Username already exist try another email");
      } else {
        window.toastr.error("<i class=\"fas fa-times\" style='margin-right: 8px'></i>There was an error please try again");
      }
      this.common.unSetLoader();
      return;
    }
    if (response.data.status === "OK") {
      const user = this.register.formatJobblerObject(this);

      this.$tracking.reportJobblerSignUp(user);
      this.tracking.fbTrackRegistration(response, user);
      this.signinJobbler();
    }
  }

  signinJobbler() {
    const user = this.register.formatJobblerObject(this);

    this.$auth.lazyLoginMobileUser(user).then(
      (response) => {
        this.handleJobblerSignin(response);
      },
      (error) => {
        alert("Error registering. Please contact support");
      }
    );
  }

  handleJobblerSignin(response) {
    this.$localStorage.logged_user = response.data;
    this.currentUser = this.$auth.getUserData();

    let user = this.$auth.getUserData();

    this.common.unSetLoader();
    this.step = 2;
  }

  sendUserToJobs() {
    this.$timeout(() => {
      $("body").removeClass();
    });

    this.$timeout(() => {
      this.$state.go("jobs");
    }, 300);
  }

  handleLogin({success, user, error}) {
    this.buttonDisabled = false;

    if (success) {
      this.buttonDisabled = false;
      this.currentUser = user;
      user.userInvited = this.userInvited;
      this.$auth.setMostRecentUser(user);
      if (user.company.totalNumberOfEvents > 0 && !this.userInvited) {
        this.$state.go("jobsdashboard");
      } else {
        if (this.userInvited) {
          if (this.isOnSiteManager === true) {
            this.$state.transitionTo("company-onboarding-2", {manager: true});
          } else {
            this.$state.go("company-onboarding-2");
          }
        } else {
          this.$state.go("company-onboarding-1");
        }
      }
    } else {
      this.$timeout(() => {
        console.log("here we end up");
        console.dir(error);
        this.remain_loading_count = 0;
        if (error.status === 401) {
        } else {
          alert(
            "Oh no! It looks like there was an error creating your account!" +
              " Please try submitting your registration information again, and" +
              " if this issue persists, please contact success@jobble.com for additional support."
          );
        }
      });
    }
  }

  checkForOnSiteManagerInvite() {
    if (this.$state.current.name === "signup-company") {
      if (this.$location.$$search.isOnsiteManager) {
        this.isOnSiteManager = true;
      } else {
        this.isOnSiteManager = false;
      }
    }

    if (this.$state.current.name === "company-onboarding-2") {
      if (this.$stateParams.manager) {
        this.isOnSiteManager = true;
      }
    }
  }

  exitPhoneVerification() {
    this.$timeout(() => {
      $("#verify-company-user-onboarding").modal("toggle");
    });
  }

  isLetter(char) {
    let c = char.toString().toUpperCase();

    return c.toUpperCase().match("[A-ZÀ-ÚÄ-Ü]+") !== null;
  }

  triggerSMSCode(response, user) {
    console.log("triggerSMSCode");
    console.dir(response);
    console.dir(user);

    this.$timeout(() => {
      this.$profile
        .sendSMSCode()
        .then((response) => {
          this.$timeout(() => {
            this.unSetLoader();
            this.displaySMSModal();
          });
        })
        .catch((err) => {
          this.$timeout(() => {
            this.unSetLoader();
          }, 300);
          this.$timeout(() => {
            alert("There was an error sending SMS code please try again later.");
          }, 500);
        });
    }, 100);
  }

  displaySMSModal() {

    this.$timeout(() => {
      this.numberToVerify = this.onboarding_data.phone_number;
      $("#verify-company-user-onboarding").modal();
    });

    this.$timeout(() => {
      $(".apply-profile-modal .modal-content .sms-code-container input:first").focus();
    }, 500);

  }

  codeEntered(num) {
    let isLetter = this.isLetter(this["smsCode_" + num]);

    if (isLetter === true) {
      this["smsCode_" + num] = null;
      return;
    }

    if (num <= 5 && this["smsCode_" + num]) {
      const el = document.getElementById("sms-code-" + (num + 1));
      el.focus();
      el.select();
    }

    let code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;

    if (code.length === 6) {
      this.validateSMSCode();
    }
  }

  smsCodeBackSpace(event, inputSequence) {
    if (event.keyCode === 8) {
      if (inputSequence !== 1) {
        let activeValue = $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + inputSequence).val();
        if (activeValue === "") {
          this.$timeout(() => {
            $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + (inputSequence - 1)).focus();
          });
        }
      }
    }
  }

  clearInputNumbers() {
    this.smsCode_1 = "";
    this.smsCode_2 = "";
    this.smsCode_3 = "";
    this.smsCode_4 = "";
    this.smsCode_5 = "";
    this.smsCode_6 = "";
    this.smsVerificationError = null;
  }

  validateSMSCode() {
    const code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;

    this.setLoader();

    this.$profile
      .validateSMSCode(code)
      .then((response) => {
        this.$timeout(() => {
          this.smsVerified = true;
          this.submitAndSaveUser();
          this.unSetLoader();
        });
      })
      .catch((err) => {
        this.$timeout(() => {
          this.smsVerificationError = true;
          this.smsVerificationErrorText = "Code invalid or expired";
          this.unSetLoader();
        }, 1000);

        this.$timeout(() => {
          alert("Verification code invalid or expired");
        }, 2000);
      });
  }

  submitAndSaveUser() {
    console.log("submitAndSaveUser");
    this.$timeout(() => {
      $("#verify-company-user-onboarding").modal("toggle");
    });

    this.$timeout(() => {
      this.setNextStep();
    }, 300);

    //this.saveUserInformation();

    /*
        const model = this.mapFields(this.ui_user_model);

        let payload = model;

        console.log("submitAndSaveUser");
        console.dir(page);
        console.dir(this.currentUser);
        console.dir(payload);

        if (page) {
            let pageValid = true;

            if (page === this.$profile.VERIFY_PHONE) {
                pageValid = this.isValidMultiple(VERIFY_PHONE_FIELDS);
                payload = this.$profile.extractFields(model, VERIFY_PHONE_FIELDS);
                this.clearInputNumbers();
            }

            if (page === this.$profile.INPUT_PHONE_NUMBER) {
                payload.homeContactInfo.isMobilePhoneVerified = true;
            }

            if (!pageValid) return;
        }

        this.savingProfile = true;

        this.$profile.saveUser(payload).then((response) => {
            if (page) this.$tracking.reportSubmitProfileStep("job board", this.$profile.STATUS_MAP[page]);

            this.$timeout(() => {
                this.$auth.refreshCurrentUser().then((user) => {
                    this.savingProfile = false;
                    this.canUserApplyToShiftBasedJobs();
                });
            }, 1000);
        });
         */
  }
}

SignupController.$inject = [
  "$http",
  "$rootScope",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "$httpParamSerializerJQLike",
  "tracking",
  "social",
  "validation",
  "ngProgressFactory",
  "signup.validator",
  "signup.routing",
  "signup.formatting",
  "signup.tracking",
  "signup.register",
  "signup.common",
  "profile",
  "companies",
  "$location",
];

export default SignupController;



// WEBPACK FOOTER //
// ./client/app/scenes/signup/signup.controller.js